<template>
  <div>
    <div class="header-title">
      <el-image src="../../static/images/logo.png" style="vertical-align:middle; margin-top:3px; margin-right:5px"></el-image>可易云
    </div>
    <div class="left-header">
      <el-menu mode="horizontal" background-color="#001529" text-color="#fff" active-text-color="#FFF">
        <el-submenu :index="Menu.path+''" v-for="Menu in Menus" :key="Menu.path" :show-timeout="200" :hide-timeout="0">
          <template slot="title">{{Menu.title}}</template>
          <div v-for="subMenu in Menu.children" :key="subMenu.id">
            <el-menu-item v-if="subMenu.path !== '-'" :index="subMenu.path" @click="menuClick(subMenu)" :key="subMenu.path">{{subMenu.title}}</el-menu-item>
            <el-divider v-else></el-divider>
          </div>
        </el-submenu>
      </el-menu>
    </div>
    
    <div class="right-header">
      <span><a @click="doRegister" class="regbutton" style="margin-right:15px" title="注册属于自己的私有帐号">注册</a></span>
      <span><a @click="phoneDlg=true" style="font-size:14px; margin-right:15px" title="安卓APP和手机浏览器版">App</a></span>
      <span><a @click="kfDlg=true" style="font-size:16px; margin-right:15px" title="在线客服咨询"><i class="el-icon-service"></i></a></span>
      
      <el-dropdown trigger="hover" @command="handleCommand">
        <span><a style="margin-right:15px"><i class="el-icon-user-solid userbutton"></i>{{myName}}<i class="el-icon-arrow-down"></i></a></span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item icon="el-icon-user" command="4">我的信息</el-dropdown-item>
          <el-dropdown-item icon="el-icon-plus" command="1">帐户续费</el-dropdown-item>
          <el-dropdown-item icon="el-icon-edit" command="2">修改密码</el-dropdown-item>
          <el-dropdown-item icon="el-icon-switch-button" command="3">安全退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      
    </div>
    
    <!-- 弹窗 -->
    <el-dialog :close-on-click-modal="false" title="打开手机上网浏览器 “扫一扫” 下面的二维码即可" :visible.sync="phoneDlg" :width="'650px'">
      <el-image src="../../static/images/apk.png"></el-image>
      <el-image src="../../static/images/web.png"></el-image>
    </el-dialog>
    
    <el-dialog :close-on-click-modal="false" title="服务咨询" :visible.sync="kfDlg" :width="'650px'">
      <el-image src="../../static/images/wxkf.png"></el-image>
      <el-image src="../../static/images/qqkf.png" @click="window.open('tencent://message/?uin=2455247199&Site=qq&Menu=yes')"></el-image>
    </el-dialog>
    
    <el-dialog :close-on-click-modal="false" title="我的信息" :visible.sync="userDlg" :width="'650px'">
      <el-descriptions :column="1" title="" style="padding-left:20px">
        <el-descriptions-item label="所属单位">{{ companyName }}</el-descriptions-item>
        <el-descriptions-item label="帐户编码">{{ userCode }}</el-descriptions-item>
        <el-descriptions-item label="帐户名称">{{ userName }}</el-descriptions-item>
        <el-descriptions-item label="所属角色">{{ userRole }}</el-descriptions-item>
        <el-descriptions-item label="有效期至">
          <el-tag size="medium">{{ overDate }}</el-tag><span style="margin-left:10px; color:red">剩余天数：{{ days }}（天） </span><span>请到期前7天内续费，过期后系统会自动注销</span>
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script>
import Menus from './menu';
import common from '../utils/common';
export default {
  data() {
    return {
      phoneDlg: false,
      kfDlg: false,
      userDlg: false,
      myName: "我",
      companyName: "",
      userCode: "",
      userName: "",
      userRole: "",
      overDate: "",
      days: -1,
      Menus,
      window: window
    }
  },
  
  mounted() {
    try {
      const loginUser = JSON.parse(localStorage.getItem('loginUser'));
      if (loginUser) {
        this.companyName = common.toStrAndTrim(loginUser.companyName);
        this.myName = common.toStrAndTrim(loginUser.userName);
      }
    }
    catch (err) {
      console.log(err);
    }
  },
  
  methods: {
    menuClick(subMenu) {
      const menuObj = {
        goods: "商品资料管理",
        goodsclass: "商品分类管理",
        employee: "职员资料管理",
        custom: "收货方资料管理",
        supplier: "供货方资料管理",
        store: "仓库设置",
        outbill: "出库单管理",
        inbill: "入库单管理",
        pdbill: "盘点单管理",
        dbbill: "调货单管理",
        viewstock: "查看库存",
        stockdetail: "出入明细表",
        outdetail: "出库单明细表",
        indetail: "入库单明细表",
        pddetail: "盘点单明细表",
        dbdetail: "调货单明细表",
        incountgoods: "按商品统计入库",
        incountunit: "按往来单位统计入库",
        incountemp: "按经手人统计入库",
        outcountgoods: "按商品统计出库",
        outcountunit: "按往来单位统计出库",
        outcountemp: "按经手人统计出库",
        lr: "商品利润",
        sys: "参数设置",
        role: "角色权限",
        user: "操作员管理",
        clear: "清除数据"
      }
      
      if (menuObj[subMenu.name]) {
        if (!common.checkUserPower(menuObj[subMenu.name], 'canview')) {
          common.msgPopInfo('您所在的角色组无权限使用该功能！');
          return false;
        }
      }
      
      this.$store.commit('addTag', subMenu);
      this.$router.push({ path: subMenu.path });
    },
    
    //注册
    doRegister() {
      this.$store.commit('clearTag');
      sessionStorage.clear();
      this.$router.push({ path: "/register" });
      this.$router.go(0);
    },
    
    async handleCommand(item) {
      //退出系统
      if (item.toString() === '3') {
        if (await common.msgAsk('是否要退出系统?')) {
          this.isDemo = false;
          this.$router.push({ path: "/out" });
        }
      }
      
      //显示我的信息
      else if (item.toString() === '4') {
        try {
          let aryData;
          const res = await this.$axios.get(common.serverApi(`user`));
          if (res.data.code === 1000) {
            if (Array.isArray(res.data.result)) {
              aryData = res.data.result;
              for (let i = 0; i < aryData.length; i++) {
                if ((aryData[i].usercode === this.myName) || (aryData[i].username === this.myName)) {
                  this.userDlg = true;
                  
                  this.userCode = aryData[i].usercode;
                  this.userName = aryData[i].username;
                  this.userRole = aryData[i].rolename;
                  this.overDate = aryData[i].overdate;
                  this.days = common.getDays(common.getNowDate(), this.overDate);
                  break;
                }
              }
            }
          }
          else {
            if (res.data.code === 1005) {
              await common.msgPopInfo(res.data.message);
              this.$router.push({ path: "/out" });
            }
            common.msgError(res.data.message);
          }
        }
        catch (err) {
          console.log(err);
          common.msgError("获取我的信息异常");
        }
      }
      
      //续费
      else if (item.toString() === '1') {
        this.kfDlg = true;
      }
      
      //修改密码
      else if (item.toString() === '2') {
        const pwd = {
          id: "44",
          path: "/password",
          name: "password",
          title: "修改密码"
        }
        
        this.$router.push({ path: pwd.path });
        this.$store.commit('addTag', pwd);
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/header.vue